<template>
  <section
    class="my-account"
    aria-labelledby="deposit-title"
    role="link"
    tabindex="0"
    @click="goToBalanceDeposit"
    @keydown.enter="goToBalanceDeposit"
  >
    <div class="my-account__summary">
      <p id="deposit-title" class="my-account__label">예치금</p>
      <p class="my-account__amount"><LoadingText :is-loading="withdrawBalanceLoading">{{ withdrawBalance | commaFormat }}</LoadingText><span>원</span></p>
    </div>

    <div class="my-account__numbers">
      <div class="account-row">
        <span v-if="profile && profile.vaccount">펀다에이아이 계좌 · {{ profile.vaccount.bankCode | bankName }}</span>
        <span v-else>펀다에이아이 계좌 · -</span>
        <strong>{{ profile && profile.vaccount ? profile.vaccount.accountNo : '-' }}</strong>
      </div>
      <div class="account-row">
        <span v-if="waccount">등록 계좌 · {{ waccount.bankCode | bankName }}</span>
        <span v-else>등록 계좌 · -</span>
        <strong>{{ waccount ? waccount.accountNo : '-' }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AuthTypes } from '@/store/types/auth'
import LoadingText from '@/components/common/text/LoadingText.vue'

export default {
  components: {
    LoadingText,
  },
  props: {
    withdrawBalance: {
      type: Number,
      default: 0,
    },
    withdrawBalanceLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      waccount: null,
    }
  },
  computed: {
    ...mapGetters('auth', {
      profile: AuthTypes.getters.GET_PROFILE,
    }),
  },
  async created() {
    await this.getWaccount()
  },
  methods: {
    ...mapActions('auth', {
      GET_PAYMENT_USER: AuthTypes.actions.GET_PAYMENT_USER,
    }),
    goToBalanceDeposit() {
      this.$router.push({ name: 'myfunda-balance-deposit' })
    },
    async getWaccount() {
      let data = this.profile?.paymentUser
      if (!data) {
        data = await this.GET_PAYMENT_USER()
      }
      if (data) {
        this.waccount = data.withdrawAccount
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.my-account {
  min-height: 220px;
  padding: 28px 30px;
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(320px, 1.1fr);
  align-items: center;
  gap: 30px;
  background: linear-gradient(135deg, #00ade5 0%, #0b93d0 100%);
  border-radius: 14px;
  color: #fff;
  cursor: pointer;
  overflow: hidden;
}

.my-account__summary,
.my-account__numbers {
  min-width: 0;
}

.my-account__label {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  opacity: 0.88;
}

.my-account__amount {
  margin: 6px 0 22px;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.my-account__amount span {
  margin-left: 3px;
  font-size: 18px;
  font-weight: 600;
}

.my-account:focus-visible {
  outline: 3px solid rgba(0, 173, 229, 0.35);
  outline-offset: 3px;
}

.my-account__numbers {
  padding: 17px 20px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
}

.account-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  line-height: 1.5;
}

.account-row + .account-row {
  margin-top: 8px;
}

.account-row strong {
  min-width: 0;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

@media screen and (max-width: 1264px) {
  .my-account {
    min-height: 0;
    padding: 24px 22px;
    display: block;
    border-radius: 12px;
  }

  .my-account__amount {
    font-size: 32px;
  }

  .my-account__numbers {
    margin-top: 22px;
    padding: 16px;
  }

  .account-row {
    font-size: 12px;
  }
}
</style>
